export default 'The number is too low.';